export default class SMSAlertService { 
  public static AddMemeber(portfolioID: number, phone: string): Promise<any> {
    return new Promise((resolve, reject) => {
      const request = new XMLHttpRequest() as any;
      request.open('post',  '/api/portfolio/' + portfolioID + '/SMSAlert', true);      
      request.withCredentials = true;

      request.setRequestHeader('Content-Type', 'application/json');
      request.setRequestHeader('Accept', 'application/json');      
      
      request.onload = function() {
        if (request.status >= 200 && request.status < 400) {          
          const data = JSON.parse(request.responseText);
          if (data.responseCode != 0) {
            reject();
          } else {
            resolve(data.payload);
          }
        } else {
          // We reached our target server, but it returned an error
          reject();
        }
      };

      request.onerror = function() {
        reject();
      };

      request.send(JSON.stringify({phone: phone}));      
    });
  } 
}
